<template>
  <ion-grid>
    <ion-row style="background: #eaf2fc">
      <ion-col size="12" size-md="8">
        <ion-chip :color="answer && answer.option ? 'success':'secondary'">
          <ion-label>{{ quizItem.order }}</ion-label>
          <ion-icon v-if="answer" :icon="checkmarkCircleOutline"></ion-icon>
        </ion-chip>
        <span style="font-size:medium">{{ quizItem.title }}</span>
        <ion-icon v-if="quizItem.detail || quizItem.tip" @click="showToast()" style="padding-left: 3px"
                  :icon="informationCircleOutline"></ion-icon>
      </ion-col>
    </ion-row>
    <ion-row v-if="quizItem.code === 'deg' || quizItem.code === 'msc'">
      <ion-col size="12" size-md="6" class="p-0">
        <ion-item lines="none">
          <ion-label position="floating" style="margin-bottom: 5px; font-size: large">Stream</ion-label>
          <ion-select placeholder="Select" interface="action-sheet" v-model="answer.option" :class="{'completed-quiz': answer && answer.option != null}"
                      v-on:ionChange="selectOption2($event)">
            <ion-select-option v-for="o of options" v-bind:key="o.code" v-bind:value="o">{{ o.name }}</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>
      <ion-col size="12" size-md="6" class="p-0">
        <ion-item lines="none">
          <ion-label position="floating" style="margin-bottom: 5px; font-size: large">GPA</ion-label>
          <ion-input placeholder="GPA" interface="action-sheet" v-model="answer.grades.gpa" type="number" value="0.0"
                     class="default-select" style="padding-left: 1em!important; max-width: 8em; min-width: 8em"
                     v-bind::class="{'completed-quiz': answer.grades.gpa > 0}"
                     @ionChange="dataChanged()">
          </ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" size-md="6" class="p-0">
        <ion-item lines="none">
          <ion-label position="floating" style="margin-bottom: 5px; font-size: large">Country of the institute</ion-label>
          <ion-select class="qualifier_select" color="dark" :multiple="multiSelect" placeholder="Select" interface="popover"
                      v-bind:class="{'completed-quiz': answer.grades.country}"
                      v-model="answer.grades.country"
                      v-on:click="openDataListSelect('country','country', null, null, (answer.grades.country ? [answer.grades.country] : [] )); $event.stopImmediatePropagation()">
            <ion-select-option v-bind:value="answer.grades.country">{{ answer.grades.country ? answer.grades.country.name : 'Select' }}</ion-select-option>
          </ion-select>

        </ion-item>
      </ion-col>
      <ion-col size="12" size-md="6" class="p-0">
        <ion-item lines="none">
          <ion-label position="floating" style="margin-bottom: 5px; font-size: large">University</ion-label>
          <ion-select class="qualifier_select" color="dark" :multiple="multiSelect" placeholder="Select" interface="popover"
                      v-bind:class="{'completed-quiz': answer.grades.university}"
                      v-model="answer.grades.university"
                      v-on:click="openDataListSelect('university','university',
                        (answer.grades.country ? answer.grades.country.code : null),null,
                        (answer.grades.university?[answer.grades.university]:[])); $event.stopImmediatePropagation()">
            <ion-select-option v-bind:value="answer.grades.university">{{ answer.grades.university ? answer.grades.university.name : 'Select' }}</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>
    </ion-row>
    <template v-if="quizItem.code === 'al' || quizItem.code === 'ol'">
      <ion-row>
        <ion-col size="12" size-md="4" v-for="su of answer.grades.subjects" v-bind:key="su.code">
          <ion-item lines="none">
            <ion-label position="floating" style="margin-bottom: 5px; font-size: large">{{ su.name || su.code }}</ion-label>
            <!--          <ion-label position="stacked">{{su.name || su.code}}</ion-label>-->
            <ion-select placeholder="Select Grade" interface="action-sheet"
                        v-model="su.grade"
                        v-bind:class="{'completed-quiz': su.grade}"
                        @ionChange="dataChanged()"
                        style="margin-top: 4px">
              <ion-select-option v-for="opt of quizItem.grades.options" v-bind:value="opt.code" v-bind:key="opt.code">{{ opt.name }}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col size="12" v-if="quizItem.code === 'al'">
          <ion-item lines="none">
            <ion-button fill="outline" size="medium" style="padding-right: 0"
                        v-on:click="openDataListSelect('al-subjects','subjects',null, null,answer.grades.subjects,true)">
              Select Subjects
            </ion-button>
          </ion-item>
        </ion-col>

      </ion-row>
    </template>
  </ion-grid>
</template>

<script>
import {
  IonGrid,
  IonRow,
  IonCol,
  IonChip,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonSelect,
  IonButton,
  IonSelectOption,
  modalController,
  isPlatform
} from '@ionic/vue';
import {
  checkmarkCircleOutline,
  informationCircleOutline
} from 'ionicons/icons';

import EoppService from "@/mixins/EoppService";
import DataListSelect from "@/components/DataListSelect";

export default {
  name: 'QuizItemGradeSelect',
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonChip,
    IonInput,
    IonButton,
    IonIcon,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption
  },
  mixins: [EoppService],
  data() {
    return {
      checkmarkCircleOutline,
      informationCircleOutline,
      answer: {
        completed: false,
        option: null,
        grades: {}
      },
      options: []
    };
  },
  mounted() {
    if (this.quizItem._answer) {
      this.answer = this.quizItem._answer;
    }

    if (this.quizItem.code === 'ol') {
      (this.answer.grades.subjects || []).forEach(o => {
        let opt = this.quizItem.options.find(s => s.code === o.code);
        if (opt) {
          opt.grade = o.grade;
        }
      })
      this.answer.grades.subjects = this.quizItem.options;
    }

    if (this.quizItem.data_key) {
      this.loadOptions();
    } else {
      this.options = this.quizItem.options;
      this.initPreviousAnswer();
    }
  },
  props: {
    quizItem: {
      type: Object,
      required: false
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    withPreference: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    initPreviousAnswer() {
      if (this.answer.option) {
        this.answer.option = (this.options || []).find(o => o.code === this.answer.option.code);
      }
    },
    loadOptions() {
      this.getData(`/data?key=${this.quizItem.data_key}`).then(res => {
        if (res && res.data) {
          // @ts-ignore
          res.data.sort((a, b) => {
            return a.name.localeCompare(b.name)
          });
          this.options = res.data;
        }
        this.initPreviousAnswer();
      })
    },
    selectOption(event) {
      this.answer = event.detail.value;
      this.dataChanged();
    },
    selectOption2(event) {
      this.answer.option = event.detail.value;
      this.dataChanged();
    },
    getBtnLabel(cat) {
      if (this.quizItem._answer && this.quizItem._answer.grades[cat]) {
        return this.quizItem._answer.grades[cat].name;
      } else {
        return 'Select';
      }
    },
    dataChanged() {
      this.$emit('answer', this.answer);
    },
    isShowDataList() {
      return this.multiSelect || isPlatform('desktop') && this.quizItem.data_key != null;
    },
    async openDataListSelect(key, variable, code = null, items = null, current = null, multiSelect = false, withPreference = false, showOtherOption = false) {

      if (key === 'university' && this.answer.grades.country === undefined) {
        this.toast('Warning', 'Please Select the Country First');
        return;
      }
      const modal = await modalController
          .create({
            component: DataListSelect,
            cssClass: 'my-custom-class',
            componentProps: {
              dataKey: key,
              code,
              multiSelect,
              withPreference,
              current,
              items,
              showOtherOption
            },
          });

      modal.onDidDismiss().then(res => {
        console.log(res);
        if (res.data) {
          this.answer.grades[variable] = res.data;
          this.dataChanged();
        }
      });

      return modal.present();
    },
  }
}
</script>
<style>
ion-select {
  max-width: 100%;
  /*background-color: #bbb;*/
  color: var(--ion-color-secondary);
  border: thin solid var(--ion-color-secondary);
  /*border: thin solid red;*/
  border-radius: 10px;
  padding-left: 1em;
}

.default-select {
  color: var(--ion-color-secondary);
  border: thin solid var(--ion-color-secondary);
  border-radius: 10px;
  padding-left: 1em;
  min-width: 100%;
}

.completed-quiz {
  color: var(--ion-color-success);
  border: thin solid var(--ion-color-success);
  border-radius: 10px;
  padding-left: 1em;
}

ion-input {
  --padding-start: 12px;
}

/*.completed-quiz-bg {*/
/*  background: var(--ion-color-success);*/
/*  border: thin solid var(--ion-color-success);*/
/*}*/
</style>
